class UtmGrabber {
    constructor(cookieIdentifier, useObserver = false, useCookie = false, parameters = [], values = {}) {
        this.cookieIdentifier = cookieIdentifier;
        this.parameters = parameters;

        if (useCookie) {
            this.parsedValues = this.getCookie();
        } else {
            this.parsedValues = values;
        }

        if (Object.keys(this.parsedValues).length === 0) {
            return;
        }

        this.selectors = this.parameters.map((parameter) => {
            const identifier = CSS.escape(parameter.trim());

            return `input#${identifier},input#form-field-${identifier},input[name="${identifier}"]`;
        }).join(',');

        this.onLoaded();
        if (!useObserver) {
            return;
        }

        this.createObserver();
    }

    tryAutofill(element) {
        if (!(element instanceof HTMLInputElement)) {
            return;
        }

        if (element.type !== 'hidden') {
            return;
        }

        const idIdentifier = element.id.replace('form-field-', '');
        const nameIdentifier = element.name;

        let identifier = null;
        if (this.parsedValues.hasOwnProperty(idIdentifier)) {
            identifier = idIdentifier;
        } else if (this.parsedValues.hasOwnProperty(nameIdentifier)) {
            identifier = nameIdentifier;
        }

        if (identifier === null) {
            return;
        }

        let value = this.parsedValues[identifier].toString();
        if (element.maxLength > 0) {
            value = value.slice(0, element.maxLength);
        }

        element.value = value;
    }

    onLoaded() {
        const elements = document.querySelectorAll(this.selectors);
        for (const element of elements) {
            this.tryAutofill(element);
        }
    }

    createObserver() {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    this.tryAutofill(node);
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
    }

    getCookie() {
        let name = this.cookieIdentifier + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');

        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }

            if (c.indexOf(name) === 0) {
                return JSON.parse(c.substring(name.length, c.length));
            }
        }

        return {};
    }
}

document.addEventListener('DOMContentLoaded', function () {
    new UtmGrabber(
        settings.identifier,
        settings.useObserver === '1',
        settings.useCookie === '1',
        Array.from(Object.values(settings.parameters)) ?? [],
        settings.values ?? {},
    );
});
